/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import React, { useContext, useMemo, useState, useEffect } from "react";
import "../../CSS/general.css";
import ActionButtons from "./ActionButton";
import AuthenticationContext from "../../Store/Authentication-Context";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import LoaderGif from "../../images/365 loading.gif";

const Step3 = (props) => {
    ////const [gridApi, setGridApi] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [rowData, setRowData] = useState(null);
    const { setAuthContext } = useContext(AuthenticationContext);
    const validate = () => {
        setDisabled(true);
        props.nextStep();

    };


    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        flex: 1
    }), []);

    const columnDefs = [
       
        { field: 'orgName', sortable: true, headerName: 'Organisation Name', width: 170, },
        { field: 'cwCompanyID', sortable: true,headerName: 'Company ID', width: 160, },
        { field: 'cwAgreementID', sortable: true, headerName: 'Agreement ID', width: 170, },

    ];

    const onGridReady = (params) => {
        ////setGridApi(params.api);
       
    }

    const createSubAgreement = async () => {

        const tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        try {

            await Axios.post(API_ROUTE + Routes.CREATE_CONNECTWISE_SUBAGREEMENTS, "", config)
                .then((response) => {
                   
                        setDisabled(false);
                      
                    
                })
                .catch((error) => {
                    console.error("Error creating contact:", error);
                });


        } catch (error) {
            console.error("Error in CreateContacts:", error);
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
        props.getallAggreements();
    }
    useEffect(() => {
        setDisabled(true);
        createSubAgreement();
        setRowData(props.uniqueAdditionLines.filter(line => line.cwAgreementStatus === 'Created'));
       
    }, [props.uniqueAdditionLines]);

    return (<div id="step2">
        <div>
            <div id="UpdatePanel1">
                <div className="card">
                    <h4 className="card-header ">
                        <span id="TitleLabel" className="SectionTitle">Created Agreements&nbsp;</span>
                  
                    </h4>
                    <div className="card-body" style={{ borderStyle: "None", height: "400px", width: "100%" }}>
                        <div className="ag-theme-alpine ms-2" style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "99%", height: '100%', overflowY: "auto" }}>
                            {disabled === true ?
                                <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                    <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                    <span className="visually-hidden">Loading...</span>
                                </div> :
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={rowData}
                                    onGridReady={onGridReady}
                                    defaultColDef={defaultColDef}
                                    domLayout="normal"
                                    overlayLoadingTemplate={
                                        `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                    overlayNoRowsTemplate={
                                        '<span className="ag-overlay-loading-center">No new Agreements have been created.</span>'
                                    }
                                />
                            }
                        </div>
                    </div>
                    <div>
                        <table cellSpacing="5" cellPadding="5" align="right">
                            <tbody>
                                <tr>
                                    <td align="right">
                                        <ActionButtons {...props} isDisabled={disabled} nextStep={validate} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </div >
    );
}
export default Step3;
